import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({ children }) {
  const { pathname } = useLocation();
  const [showChildren, setShowChildren] = useState(false);

  useEffect(() => {
    // Instantly jump to top
    window.scrollTo(0, 0);

    // Wait for scroll to complete, then show content
    requestAnimationFrame(() => {
      setShowChildren(true);
    });

    return () => {
      // Hide children before next route
      setShowChildren(false);
    };
  }, [pathname]);

  return showChildren ? children : null;
}
